export default {
    name: 'GridHeaderRow',
    template: '<div><slot></slot></div>',
    data() {
        return {
            columns: [],
            timer: null
        }
    },
    watch: {
        columns() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$parent.$parent.initColumns()
                this.$parent.$parent.initHeaderHeight()
                this.timer = null;
            })
        }
    },
    mounted() {
        this.$parent.addRow(this);
    },
    destroyed() {
        this.$parent.removeRow(this);
    },
    methods: {
        addColumn(column) {
            this.columns.push(column);
            this.columns = [].concat(this.columns);
        },
        removeColumn(column) {
            let index = this.columns.indexOf(column);
            if (index >= 0) {
                this.columns.splice(index, 1);
            }
        },

    }
}